import { StyleSheet, View } from 'react-native';
import { type PaymentPlanReviewLink } from 'shared/components/lending/paymentPlanReview/PaymentPlanReviewLayout/PaymentPlanReviewLayout';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import HyperlinkBaseText from 'shared/components/vxl/typography/primary/hyperlink/HyperlinkBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

interface PaymentPlanHeaderProps {
  title: string;
  summary: string;
  summaryLink?: PaymentPlanReviewLink;
}

const PaymentPlanHeader = ({
  title,
  summary,
  summaryLink,
}: PaymentPlanHeaderProps) => {
  return (
    <View style={styles.container}>
      <TitleLgText numberOfLines={0}>{title}</TitleLgText>
      <BodyBaseText numberOfLines={0}>
        {summary}
        {summaryLink ? (
          <>
            {' '}
            <HyperlinkBaseText
              onPress={summaryLink.onPress}
              analyticsId={summaryLink.analyticsId}
            >
              {summaryLink.label}
            </HyperlinkBaseText>
          </>
        ) : null}
      </BodyBaseText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: theme.spacing.m,
    gap: theme.spacing.m,
  },
});

export default PaymentPlanHeader;
